const Shield = () => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M14.7165 4.11839C14.6973 3.69746 14.6973 3.29567 14.6973 2.89387C14.6973 2.56861 14.4486 2.31988 14.1234 2.31988C11.7317 2.31988 9.91408 1.63109 8.40257 0.157848C8.17298 -0.0526158 7.82858 -0.0526158 7.59898 0.157848C6.08748 1.63109 4.26984 2.31988 1.87821 2.31988C1.55295 2.31988 1.30422 2.56861 1.30422 2.89387C1.30422 3.29567 1.30422 3.69746 1.28508 4.11839C1.20855 8.13632 1.09375 13.6466 7.80945 15.9617L8.00078 16L8.19211 15.9617C14.8887 13.6466 14.793 8.15546 14.7165 4.11839ZM7.54159 9.6861C7.42679 9.78176 7.29286 9.83916 7.13979 9.83916H7.12066C6.96759 9.83916 6.81453 9.76263 6.71887 9.64783L4.93949 7.67713L5.80048 6.91181L7.19719 8.46158L10.2967 5.5151L11.0812 6.35695L7.54159 9.6861Z'
        fill='#745BE3'
      />
    </svg>
  );
};

export default Shield;
